export interface Img_data {
    [key:number] : {
        imgurl0 : string;
        imgurl1 : string;
        imgurl2 : string;
        imgurl3 : string;
        imgurl4 : string;
        imgurl5 : string;
        imgurl6 : string;
        imgurl7 : string;
        imgurl8 : string;
        imgurl9 : string;
        imgurl10 : string;
        imgurl11 : string;
        imgurl12? : string;
        imgurl13? : string;
        imgurl14? : string;
        imgurl15? : string;
        imgurl16? : string;
        imgurl17? : string;
        imgurl18? : string;
        imgurl19? : string;
        imgurl20? : string;
    };
}

let img_data:Img_data = {
    // 0
    0 : {
        imgurl0 : '/img/detail/41/img0.jpg',
        imgurl1 : '/img/detail/41/img1.jpg',
        imgurl2 : '/img/detail/41/img2.jpg',
        imgurl3 : '/img/detail/41/img3.jpg',
        imgurl4 : '/img/detail/41/img4.jpg',
        imgurl5 : '/img/detail/41/img5.jpg',
        imgurl6 : '/img/detail/41/img6.jpg',
        imgurl7 : '/img/detail/41/img7.jpg',
        imgurl8 : '/img/detail/41/img8.jpg',
        imgurl9 : '/img/detail/41/img9.jpg',
        imgurl10 : '/img/detail/41/img10.jpg',
        imgurl11 : '/img/detail/41/img11.jpg',
        imgurl12 : '/img/detail/41/img12.jpg',
        imgurl13 : '/img/detail/41/img13.jpg',
        imgurl14 : '/img/detail/41/img14.jpg',
        imgurl15 : '/img/detail/41/img15.jpg',
        imgurl16 : '/img/detail/41/img16.jpg',
        imgurl17 : '/img/detail/41/img17.jpg',
        imgurl18 : '',
        imgurl19 : '',
        imgurl20 : '',
    },
    // 1
    1 : {
        imgurl0 : '/img/detail/41/img18.jpg',
        imgurl1 : '/img/detail/41/img19.jpg',
        imgurl2 : '/img/detail/41/img20.jpg',
        imgurl3 : '/img/detail/41/img21.jpg',
        imgurl4 : '/img/detail/41/img22.jpg',
        imgurl5 : '/img/detail/41/img23.jpg',
        imgurl6 : '/img/detail/41/img24.jpg',
        imgurl7 : '/img/detail/41/img25.jpg',
        imgurl8 : '/img/detail/41/img26.jpg',
        imgurl9 : '/img/detail/41/img27.jpg',
        imgurl10 : '/img/detail/41/img28.jpg',
        imgurl11 : '/img/detail/41/img29.jpg',
        imgurl12 : '/img/detail/41/img30.jpg',
        imgurl13 : '/img/detail/41/img31.jpg',
        imgurl14 : '/img/detail/41/img32.jpg',
        imgurl15 : '/img/detail/41/img33.jpg',
        imgurl16 : '/img/detail/41/img34.jpg',
        imgurl17 : '/img/detail/41/img35.jpg',
        imgurl18 : '',
        imgurl19 : '',
        imgurl20 : '',
    },
    // 2
    2 :{
        imgurl0 : '/img/detail/41/img36.jpg',
        imgurl1 : '/img/detail/41/img37.jpg',
        imgurl2 : '/img/detail/41/img38.jpg',
        imgurl3 : '/img/detail/41/img39.jpg',
        imgurl4 : '/img/detail/41/img40.jpg',
        imgurl5 : '/img/detail/41/img41.jpg',
        imgurl6 : '/img/detail/41/img42.jpg',
        imgurl7 : '/img/detail/41/img43.jpg',
        imgurl8 : '/img/detail/41/img44.jpg',
        imgurl9 : '/img/detail/41/img45.jpg',
        imgurl10 : '/img/detail/41/img46.jpg',
        imgurl11 : '/img/detail/41/img47.jpg',
        imgurl12 : '/img/detail/41/img48.jpg',
        imgurl13 : '/img/detail/41/img49.jpg',
        imgurl14 : '/img/detail/41/img50.jpg',
        imgurl15 : '/img/detail/41/img51.jpg',
        imgurl16 : '/img/detail/41/img52.jpg',
        imgurl17 : '/img/detail/41/img53.jpg',
        imgurl18 : '/img/detail/41/img54.jpg',
        imgurl19 : '/img/detail/41/img55.jpg',
        imgurl20 : '/img/detail/41/img56.jpg',
    },
    // 3
    3 :{
        imgurl0 : '/img/detail/41/img57.jpg',
        imgurl1 : '/img/detail/41/img58.jpg',
        imgurl2 : '/img/detail/41/img59.jpg',
        imgurl3 : '/img/detail/41/img60.jpg',
        imgurl4 : '/img/detail/41/img61.jpg',
        imgurl5 : '/img/detail/41/img62.jpg',
        imgurl6 : '/img/detail/41/img63.jpg',
        imgurl7 : '/img/detail/41/img64.jpg',
        imgurl8 : '/img/detail/41/img65.jpg',
        imgurl9 : '/img/detail/41/img66.jpg',
        imgurl10 : '/img/detail/41/img67.jpg',
        imgurl11 : '/img/detail/41/img68.jpg',
        imgurl12 : '/img/detail/41/img69.jpg',
        imgurl13 : '/img/detail/41/img70.jpg',
        imgurl14 : '/img/detail/41/img71.jpg',
        imgurl15 : '/img/detail/41/img72.jpg',
        imgurl16 : '/img/detail/41/img73.jpg',
        imgurl17 : '/img/detail/41/img74.jpg',
        imgurl18 : '/img/detail/41/img75.jpg',
        imgurl19 : '/img/detail/41/img76.jpg',
        imgurl20 : '/img/detail/41/img77.jpg',
    },
    // 4
    4 :{
        imgurl0 : '/img/detail/41/img78.jpg',
        imgurl1 : '/img/detail/41/img79.jpg',
        imgurl2 : '/img/detail/41/img80.jpg',
        imgurl3 : '/img/detail/41/img81.jpg',
        imgurl4 : '/img/detail/41/img82.jpg',
        imgurl5 : '/img/detail/41/img83.jpg',
        imgurl6 : '/img/detail/41/img84.jpg',
        imgurl7 : '/img/detail/41/img85.jpg',
        imgurl8 : '/img/detail/41/img86.jpg',
        imgurl9 : '/img/detail/41/img87.jpg',
        imgurl10 : '/img/detail/41/img88.jpg',
        imgurl11 : '/img/detail/41/img89.jpg',
        imgurl12 : '/img/detail/41/img90.jpg',
        imgurl13 : '/img/detail/41/img91.jpg',
        imgurl14 : '/img/detail/41/img92.jpg',
        imgurl15 : '/img/detail/41/img93.jpg',
        imgurl16 : '/img/detail/41/img94.jpg',
        imgurl17 : '/img/detail/41/img95.jpg',
        imgurl18 : '',
        imgurl19 : '',
        imgurl20 : '',
    },
    // 5
    5 :{
        imgurl0 : '/img/detail/41/img96.jpg',
        imgurl1 : '/img/detail/41/img97.jpg',
        imgurl2 : '/img/detail/41/img98.jpg',
        imgurl3 : '/img/detail/41/img99.jpg',
        imgurl4 : '/img/detail/41/img100.jpg',
        imgurl5 : '/img/detail/41/img101.jpg',
        imgurl6 : '/img/detail/41/img102.jpg',
        imgurl7 : '/img/detail/41/img103.jpg',
        imgurl8 : '/img/detail/41/img104.jpg',
        imgurl9 : '/img/detail/41/img105.jpg',
        imgurl10 : '/img/detail/41/img106.jpg',
        imgurl11 : '/img/detail/41/img107.jpg',
        imgurl12 : '/img/detail/41/img108.jpg',
        imgurl13 : '/img/detail/41/img109.jpg',
        imgurl14 : '/img/detail/41/img110.jpg',
        imgurl15 : '/img/detail/41/img111.jpg',
        imgurl16 : '/img/detail/41/img112.jpg',
        imgurl17 : '/img/detail/41/img113.jpg',
        imgurl18 : '/img/detail/41/img114.jpg',
        imgurl19 : '/img/detail/41/img115.jpg',
        imgurl20 : '/img/detail/41/img116.jpg',
    },
    // 6
    6 :{
        imgurl0 : '/img/detail/41/img117.jpg',
        imgurl1 : '/img/detail/41/img118.jpg',
        imgurl2 : '/img/detail/41/img119.jpg',
        imgurl3 : '/img/detail/41/img120.jpg',
        imgurl4 : '/img/detail/41/img121.jpg',
        imgurl5 : '/img/detail/41/img122.jpg',
        imgurl6 : '/img/detail/41/img123.jpg',
        imgurl7 : '/img/detail/41/img124.jpg',
        imgurl8 : '/img/detail/41/img125.jpg',
        imgurl9 : '/img/detail/41/img126.jpg',
        imgurl10 : '/img/detail/41/img127.jpg',
        imgurl11 : '/img/detail/41/img128.jpg',
        imgurl12 : '/img/detail/41/img129.jpg',
        imgurl13 : '/img/detail/41/img130.jpg',
        imgurl14 : '/img/detail/41/img131.jpg',
        imgurl15 : '/img/detail/41/img132.jpg',
        imgurl16 : '/img/detail/41/img133.jpg',
        imgurl17 : '/img/detail/41/img134.jpg',
        imgurl18 : '/img/detail/41/img135.jpg',
        imgurl19 : '/img/detail/41/img136.jpg',
        imgurl20 : '/img/detail/41/img137.jpg',
    },
    // 7
    7 :{
        imgurl0 : '/img/detail/41/img138.jpg',
        imgurl1 : '/img/detail/41/img139.jpg',
        imgurl2 : '/img/detail/41/img140.jpg',
        imgurl3 : '/img/detail/41/img141.jpg',
        imgurl4 : '/img/detail/41/img142.jpg',
        imgurl5 : '/img/detail/41/img143.jpg',
        imgurl6 : '/img/detail/41/img144.jpg',
        imgurl7 : '/img/detail/41/img145.jpg',
        imgurl8 : '/img/detail/41/img146.jpg',
        imgurl9 : '/img/detail/41/img147.jpg',
        imgurl10 : '/img/detail/41/img148.jpg',
        imgurl11 : '/img/detail/41/img149.jpg',
        imgurl12 : '/img/detail/41/img150.jpg',
        imgurl13 : '/img/detail/41/img151.jpg',
        imgurl14 : '/img/detail/41/img152.jpg',
        imgurl15 : '/img/detail/41/img153.jpg',
        imgurl16 : '/img/detail/41/img154.jpg',
        imgurl17 : '/img/detail/41/img155.jpg',
        imgurl18 : '/img/detail/41/img156.jpg',
        imgurl19 : '/img/detail/41/img157.jpg',
        imgurl20 : '/img/detail/41/img158.jpg',
    },
    // 8
    8 :{
        imgurl0 : '/img/detail/41/img159.jpg',
        imgurl1 : '/img/detail/41/img160.jpg',
        imgurl2 : '/img/detail/41/img161.jpg',
        imgurl3 : '/img/detail/41/img162.jpg',
        imgurl4 : '/img/detail/41/img163.jpg',
        imgurl5 : '/img/detail/41/img164.jpg',
        imgurl6 : '/img/detail/41/img165.jpg',
        imgurl7 : '/img/detail/41/img166.jpg',
        imgurl8 : '/img/detail/41/img167.jpg',
        imgurl9 : '/img/detail/41/img168.jpg',
        imgurl10 : '/img/detail/41/img169.jpg',
        imgurl11 : '/img/detail/41/img170.jpg',
        imgurl12 : '/img/detail/41/img171.jpg',
        imgurl13 : '/img/detail/41/img172.jpg',
        imgurl14 : '/img/detail/41/img173.jpg',
        imgurl15 : '/img/detail/41/img174.jpg',
        imgurl16 : '/img/detail/41/img175.jpg',
        imgurl17 : '/img/detail/41/img176.jpg',
        imgurl18 : '/img/detail/41/img177.jpg',
        imgurl19 : '/img/detail/41/img178.jpg',
        imgurl20 : '/img/detail/41/img179.jpg',
    },
    // 9
    9 :{
        imgurl0 : '/img/detail/41/img180.jpg',
        imgurl1 : '/img/detail/41/img181.jpg',
        imgurl2 : '/img/detail/41/img182.jpg',
        imgurl3 : '/img/detail/41/img183.jpg',
        imgurl4 : '/img/detail/41/img184.jpg',
        imgurl5 : '/img/detail/41/img185.jpg',
        imgurl6 : '/img/detail/41/img186.jpg',
        imgurl7 : '/img/detail/41/img187.jpg',
        imgurl8 : '/img/detail/41/img188.jpg',
        imgurl9 : '/img/detail/41/img189.jpg',
        imgurl10 : '/img/detail/41/img190.jpg',
        imgurl11 : '/img/detail/41/img191.jpg',
        imgurl12 : '/img/detail/41/img192.jpg',
        imgurl13 : '/img/detail/41/img193.jpg',
        imgurl14 : '/img/detail/41/img194.jpg',
        imgurl15 : '/img/detail/41/img195.jpg',
        imgurl16 : '/img/detail/41/img196.jpg',
        imgurl17 : '/img/detail/41/img197.jpg',
        imgurl18 : '',
        imgurl19 : '',
        imgurl20 : '',
    },
    // 10 ([6/23 예약배송][패키지] 져니홈+어뉴+투두 반팔티셔츠 2PACK (MJST7662+MJST7665+MJST7660))
    10 :{
        imgurl0 : '/img/detail/41/img198.jpg',
        imgurl1 : '/img/detail/41/img199.jpg',
        imgurl2 : '/img/detail/41/img200.jpg',
        imgurl3 : '/img/detail/41/img201.jpg',
        imgurl4 : '/img/detail/41/img202.jpg',
        imgurl5 : '/img/detail/41/img203.jpg',
        imgurl6 : '/img/detail/41/img204.jpg',
        imgurl7 : '/img/detail/41/img205.jpg',
        imgurl8 : '/img/detail/41/img206.jpg',
        imgurl9 : '/img/detail/41/img207.jpg',
        imgurl10 : '/img/detail/41/img208.jpg',
        imgurl11 : '/img/detail/41/img209.jpg',
        imgurl12 : '/img/detail/41/img210.jpg',
        imgurl13 : '/img/detail/41/img211.jpg',
        imgurl14 : '/img/detail/41/img212.jpg',
        imgurl15 : '/img/detail/41/img213.jpg',
        imgurl16 : '/img/detail/41/img214.jpg',
        imgurl17 : '/img/detail/41/img215.jpg',
        imgurl18 : '/img/detail/41/img216.jpg',
        imgurl19 : '/img/detail/41/img217.jpg',
        imgurl20 : '/img/detail/41/img218.jpg',
    },
    // 11
    11 :{
        imgurl0 : '/img/detail/41/img219.jpg',
        imgurl1 : '/img/detail/41/img220.jpg',
        imgurl2 : '/img/detail/41/img221.jpg',
        imgurl3 : '/img/detail/41/img222.jpg',
        imgurl4 : '/img/detail/41/img223.jpg',
        imgurl5 : '/img/detail/41/img224.jpg',
        imgurl6 : '/img/detail/41/img225.jpg',
        imgurl7 : '/img/detail/41/img226.jpg',
        imgurl8 : '/img/detail/41/img227.jpg',
        imgurl9 : '/img/detail/41/img228.jpg',
        imgurl10 : '/img/detail/41/img229.jpg',
        imgurl11 : '/img/detail/41/img230.jpg',
        imgurl12 : '/img/detail/41/img231.jpg',
        imgurl13 : '/img/detail/41/img232.jpg',
        imgurl14 : '/img/detail/41/img233.jpg',
        imgurl15 : '/img/detail/41/img234.jpg',
        imgurl16 : '/img/detail/41/img235.jpg',
        imgurl17 : '/img/detail/41/img236.jpg',
        imgurl18 : '/img/detail/41/img237.jpg',
        imgurl19 : '/img/detail/41/img238.jpg',
        imgurl20 : '',
    },

    // 12 ([패키지] 22s/s 반팔티 2PACK)
    12 :{
        imgurl0 : '/img/detail/41/img239.jpg',
        imgurl1 : '/img/detail/41/img240.jpg',
        imgurl2 : '/img/detail/41/img241.jpg',
        imgurl3 : '/img/detail/41/img242.jpg',
        imgurl4 : '/img/detail/41/img243.jpg',
        imgurl5 : '/img/detail/41/img244.jpg',
        imgurl6 : '/img/detail/41/img245.jpg',
        imgurl7 : '/img/detail/41/img246.jpg',
        imgurl8 : '/img/detail/41/img247.jpg',
        imgurl9 : '/img/detail/41/img248.jpg',
        imgurl10 : '/img/detail/41/img249.jpg',
        imgurl11 : '/img/detail/41/img250.jpg',
        imgurl12 : '/img/detail/41/img251.jpg',
        imgurl13 : '/img/detail/41/img252.jpg',
        imgurl14 : '/img/detail/41/img253.jpg',
        imgurl15 : '/img/detail/41/img254.jpg',
        imgurl16 : '/img/detail/41/img255.jpg',
        imgurl17 : '',
        imgurl18 : '',
        imgurl19 : '',
        imgurl20 : '',
    },
    // 13 ([패키지] 레코드+픽시+라운드 반팔티셔츠 2PACK (MJST7584+MJST7583+MJST7595))
    13 :{
        imgurl0 : '/img/detail/41/img256.jpg',
        imgurl1 : '/img/detail/41/img257.jpg',
        imgurl2 : '/img/detail/41/img258.jpg',
        imgurl3 : '/img/detail/41/img259.jpg',
        imgurl4 : '/img/detail/41/img260.jpg',
        imgurl5 : '/img/detail/41/img261.jpg',
        imgurl6 : '/img/detail/41/img262.jpg',
        imgurl7 : '/img/detail/41/img263.jpg',
        imgurl8 : '/img/detail/41/img264.jpg',
        imgurl9 : '/img/detail/41/img265.jpg',
        imgurl10 : '/img/detail/41/img266.jpg',
        imgurl11 : '/img/detail/41/img267.jpg',
        imgurl12 : '/img/detail/41/img268.jpg',
        imgurl13 : '/img/detail/41/img269.jpg',
        imgurl14 : '/img/detail/41/img270.jpg',
        imgurl15 : '/img/detail/41/img271.jpg',
        imgurl16 : '/img/detail/41/img272.jpg',
        imgurl17 : '/img/detail/41/img273.jpg',
        imgurl18 : '/img/detail/41/img274.jpg',
        imgurl19 : '/img/detail/41/img275.jpg',
        imgurl20 : '/img/detail/41/img276.jpg',
    },
    // 14 ([패키지] 스티비베어+스티비 컬리지+올디 반팔티셔츠 2PACK (JJST7596+SHST7597+JIST7587))
    14 :{
        imgurl0 : '/img/detail/41/img277.jpg',
        imgurl1 : '/img/detail/41/img278.jpg',
        imgurl2 : '/img/detail/41/img279.jpg',
        imgurl3 : '/img/detail/41/img280.jpg',
        imgurl4 : '/img/detail/41/img281.jpg',
        imgurl5 : '/img/detail/41/img282.jpg',
        imgurl6 : '/img/detail/41/img283.jpg',
        imgurl7 : '/img/detail/41/img284.jpg',
        imgurl8 : '/img/detail/41/img285.jpg',
        imgurl9 : '/img/detail/41/img286.jpg',
        imgurl10 : '/img/detail/41/img287.jpg',
        imgurl11 : '/img/detail/41/img288.jpg',
        imgurl12 : '/img/detail/41/img289.jpg',
        imgurl13 : '/img/detail/41/img290.jpg',
        imgurl14 : '/img/detail/41/img291.jpg',
        imgurl15 : '/img/detail/41/img292.jpg',
        imgurl16 : '/img/detail/41/img293.jpg',
        imgurl17 : '/img/detail/41/img294.jpg',
        imgurl18 : '/img/detail/41/img295.jpg',
        imgurl19 : '/img/detail/41/img296.jpg',
        imgurl20 : '/img/detail/41/img297.jpg',
    },
    // 15 (라이닝 니트 베스트 라이트베이지 JNKN7669)
    15 :{
        imgurl0 : '/img/detail/41/img298.jpg',
        imgurl1 : '/img/detail/41/img299.jpg',
        imgurl2 : '/img/detail/41/img300.jpg',
        imgurl3 : '/img/detail/41/img301.jpg',
        imgurl4 : '/img/detail/41/img302.jpg',
        imgurl5 : '/img/detail/41/img303.jpg',
        imgurl6 : '/img/detail/41/img304.jpg',
        imgurl7 : '/img/detail/41/img305.jpg',
        imgurl8 : '/img/detail/41/img306.jpg',
        imgurl9 : '/img/detail/41/img307.jpg',
        imgurl10 : '/img/detail/41/img308.jpg',
        imgurl11 : '/img/detail/41/img309.jpg',
        imgurl12 : '/img/detail/41/img310.jpg',
        imgurl13 : '/img/detail/41/img311.jpg',
        imgurl14 : '/img/detail/41/img312.jpg',
        imgurl15 : '/img/detail/41/img313.jpg',
        imgurl16 : '/img/detail/41/img314.jpg',
        imgurl17 : '/img/detail/41/img315.jpg',
        imgurl18 : '/img/detail/41/img316.jpg',
        imgurl19 : '/img/detail/41/img317.jpg',
        imgurl20 : '/img/detail/41/img318.jpg',
    },
    // 16
    16 :{
        imgurl0 : '/img/detail/41/img319.jpg',
        imgurl1 : '/img/detail/41/img320.jpg',
        imgurl2 : '/img/detail/41/img321.jpg',
        imgurl3 : '/img/detail/41/img322.jpg',
        imgurl4 : '/img/detail/41/img323.jpg',
        imgurl5 : '/img/detail/41/img324.jpg',
        imgurl6 : '/img/detail/41/img325.jpg',
        imgurl7 : '/img/detail/41/img326.jpg',
        imgurl8 : '/img/detail/41/img327.jpg',
        imgurl9 : '/img/detail/41/img328.jpg',
        imgurl10 : '/img/detail/41/img329.jpg',
        imgurl11 : '/img/detail/41/img330.jpg',
        imgurl12 : '/img/detail/41/img331.jpg',
        imgurl13 : '/img/detail/41/img332.jpg',
        imgurl14 : '/img/detail/41/img333.jpg',
        imgurl15 : '/img/detail/41/img334.jpg',
        imgurl16 : '/img/detail/41/img335.jpg',
        imgurl17 : '/img/detail/41/img336.jpg',
        imgurl18 : '/img/detail/41/img337.jpg',
        imgurl19 : '/img/detail/41/img338.jpg',
        imgurl20 : '/img/detail/41/img339.jpg',
    },
    // 17
    17 :{
        imgurl0 : '/img/detail/41/img340.jpg',
        imgurl1 : '/img/detail/41/img341.jpg',
        imgurl2 : '/img/detail/41/img342.jpg',
        imgurl3 : '/img/detail/41/img343.jpg',
        imgurl4 : '/img/detail/41/img344.jpg',
        imgurl5 : '/img/detail/41/img345.jpg',
        imgurl6 : '/img/detail/41/img346.jpg',
        imgurl7 : '/img/detail/41/img347.jpg',
        imgurl8 : '/img/detail/41/img348.jpg',
        imgurl9 : '/img/detail/41/img349.jpg',
        imgurl10 : '/img/detail/41/img350.jpg',
        imgurl11 : '/img/detail/41/img351.jpg',
        imgurl12 : '/img/detail/41/img352.jpg',
        imgurl13 : '/img/detail/41/img353.jpg',
        imgurl14 : '/img/detail/41/img354.jpg',
        imgurl15 : '/img/detail/41/img355.jpg',
        imgurl16 : '/img/detail/41/img356.jpg',
        imgurl17 : '/img/detail/41/img357.jpg',
        imgurl18 : '/img/detail/41/img358.jpg',
        imgurl19 : '/img/detail/41/img359.jpg',
        imgurl20 : '/img/detail/41/img360.jpg',
    },
    // 18 
    18 :{
        imgurl0 : '/img/detail/41/img361.jpg',
        imgurl1 : '/img/detail/41/img362.jpg',
        imgurl2 : '/img/detail/41/img363.jpg',
        imgurl3 : '/img/detail/41/img364.jpg',
        imgurl4 : '/img/detail/41/img365.jpg',
        imgurl5 : '/img/detail/41/img366.jpg',
        imgurl6 : '/img/detail/41/img367.jpg',
        imgurl7 : '/img/detail/41/img368.jpg',
        imgurl8 : '/img/detail/41/img369.jpg',
        imgurl9 : '/img/detail/41/img370.jpg',
        imgurl10 : '/img/detail/41/img371.jpg',
        imgurl11 : '/img/detail/41/img372.jpg',
        imgurl12 : '/img/detail/41/img373.jpg',
        imgurl13 : '/img/detail/41/img374.jpg',
        imgurl14 : '/img/detail/41/img375.jpg',
        imgurl15 : '/img/detail/41/img376.jpg',
        imgurl16 : '/img/detail/41/img377.jpg',
        imgurl17 : '/img/detail/41/img378.jpg',
        imgurl18 : '/img/detail/41/img379.jpg',
        imgurl19 : '/img/detail/41/img380.jpg',
        imgurl20 : '',
    },
    // 19 (라이닝 니트 베스트 라벤더 JNKN7669)
    19 :{
        imgurl0 : '/img/detail/41/img381.jpg',
        imgurl1 : '/img/detail/41/img382.jpg',
        imgurl2 : '/img/detail/41/img383.jpg',
        imgurl3 : '/img/detail/41/img384.jpg',
        imgurl4 : '/img/detail/41/img385.jpg',
        imgurl5 : '/img/detail/41/img386.jpg',
        imgurl6 : '/img/detail/41/img387.jpg',
        imgurl7 : '/img/detail/41/img388.jpg',
        imgurl8 : '/img/detail/41/img389.jpg',
        imgurl9 : '/img/detail/41/img390.jpg',
        imgurl10 : '/img/detail/41/img391.jpg',
        imgurl11 : '/img/detail/41/img392.jpg',
        imgurl12 : '/img/detail/41/img393.jpg',
        imgurl13 : '/img/detail/41/img394.jpg',
        imgurl14 : '/img/detail/41/img395.jpg',
        imgurl15 : '/img/detail/41/img396.jpg',
        imgurl16 : '/img/detail/41/img397.jpg',
        imgurl17 : '/img/detail/41/img398.jpg',
        imgurl18 : '/img/detail/41/img399.jpg',
        imgurl19 : '/img/detail/41/img400.jpg',
        imgurl20 : '/img/detail/41/img401.jpg',
    },
    // 20 
    20 :{
        imgurl0 : '/img/detail/41/img402.jpg',
        imgurl1 : '/img/detail/41/img403.jpg',
        imgurl2 : '/img/detail/41/img404.jpg',
        imgurl3 : '/img/detail/41/img405.jpg',
        imgurl4 : '/img/detail/41/img406.jpg',
        imgurl5 : '/img/detail/41/img407.jpg',
        imgurl6 : '/img/detail/41/img408.jpg',
        imgurl7 : '/img/detail/41/img409.jpg',
        imgurl8 : '/img/detail/41/img410.jpg',
        imgurl9 : '/img/detail/41/img411.jpg',
        imgurl10 : '/img/detail/41/img412.jpg',
        imgurl11 : '/img/detail/41/img413.jpg',
        imgurl12 : '/img/detail/41/img414.jpg',
        imgurl13 : '/img/detail/41/img415.jpg',
        imgurl14 : '/img/detail/41/img416.jpg',
        imgurl15 : '/img/detail/41/img417.jpg',
        imgurl16 : '/img/detail/41/img418.jpg',
        imgurl17 : '/img/detail/41/img419.jpg',
        imgurl18 : '/img/detail/41/img420.jpg',
        imgurl19 : '/img/detail/41/img421.jpg',
        imgurl20 : '/img/detail/41/img422.jpg',
    },
    // 21 
    21 :{
        imgurl0 : '/img/detail/41/img423.jpg',
        imgurl1 : '/img/detail/41/img424.jpg',
        imgurl2 : '/img/detail/41/img425.jpg',
        imgurl3 : '/img/detail/41/img426.jpg',
        imgurl4 : '/img/detail/41/img427.jpg',
        imgurl5 : '/img/detail/41/img428.jpg',
        imgurl6 : '/img/detail/41/img429.jpg',
        imgurl7 : '/img/detail/41/img430.jpg',
        imgurl8 : '/img/detail/41/img431.jpg',
        imgurl9 : '/img/detail/41/img432.jpg',
        imgurl10 : '/img/detail/41/img433.jpg',
        imgurl11 : '/img/detail/41/img434.jpg',
        imgurl12 : '/img/detail/41/img435.jpg',
        imgurl13 : '/img/detail/41/img436.jpg',
        imgurl14 : '/img/detail/41/img437.jpg',
        imgurl15 : '/img/detail/41/img438.jpg',
        imgurl16 : '/img/detail/41/img439.jpg',
        imgurl17 : '/img/detail/41/img440.jpg',
        imgurl18 : '/img/detail/41/img441.jpg',
        imgurl19 : '/img/detail/41/img442.jpg',
        imgurl20 : '',
    },
    // 22 
    22 :{
        imgurl0 : '/img/detail/41/img624.jpg',
        imgurl1 : '/img/detail/41/img625.jpg',
        imgurl2 : '/img/detail/41/img626.jpg',
        imgurl3 : '/img/detail/41/img627.jpg',
        imgurl4 : '/img/detail/41/img628.jpg',
        imgurl5 : '/img/detail/41/img629.jpg',
        imgurl6 : '/img/detail/41/img630.jpg',
        imgurl7 : '/img/detail/41/img631.jpg',
        imgurl8 : '/img/detail/41/img632.jpg',
        imgurl9 : '/img/detail/41/img633.jpg',
        imgurl10 : '/img/detail/41/img634.jpg',
        imgurl11 : '/img/detail/41/img635.jpg',
        imgurl12 : '/img/detail/41/img636.jpg',
        imgurl13 : '/img/detail/41/img637.jpg',
        imgurl14 : '/img/detail/41/img638.jpg',
        imgurl15 : '/img/detail/41/img639.jpg',
        imgurl16 : '/img/detail/41/img640.jpg',
        imgurl17 : '/img/detail/41/img641.jpg',
        imgurl18 : '/img/detail/41/img642.jpg',
        imgurl19 : '/img/detail/41/img643.jpg',
        imgurl20 : '/img/detail/41/img644.jpg',
    },
    // 23 
    23 :{
        imgurl0 : '/img/detail/41/img443.jpg',
        imgurl1 : '/img/detail/41/img444.jpg',
        imgurl2 : '/img/detail/41/img445.jpg',
        imgurl3 : '/img/detail/41/img446.jpg',
        imgurl4 : '/img/detail/41/img447.jpg',
        imgurl5 : '/img/detail/41/img448.jpg',
        imgurl6 : '/img/detail/41/img449.jpg',
        imgurl7 : '/img/detail/41/img450.jpg',
        imgurl8 : '/img/detail/41/img451.jpg',
        imgurl9 : '/img/detail/41/img452.jpg',
        imgurl10 : '/img/detail/41/img453.jpg',
        imgurl11 : '/img/detail/41/img454.jpg',
        imgurl12 : '/img/detail/41/img455.jpg',
        imgurl13 : '/img/detail/41/img456.jpg',
        imgurl14 : '/img/detail/41/img457.jpg',
        imgurl15 : '/img/detail/41/img458.jpg',
        imgurl16 : '/img/detail/41/img459.jpg',
        imgurl17 : '/img/detail/41/img460.jpg',
        imgurl18 : '/img/detail/41/img461.jpg',
        imgurl19 : '/img/detail/41/img462.jpg',
        imgurl20 : '/img/detail/41/img463.jpg',
    },
    // 24 
    24 :{
        imgurl0 : '/img/detail/41/img464.jpg',
        imgurl1 : '/img/detail/41/img465.jpg',
        imgurl2 : '/img/detail/41/img466.jpg',
        imgurl3 : '/img/detail/41/img467.jpg',
        imgurl4 : '/img/detail/41/img468.jpg',
        imgurl5 : '/img/detail/41/img469.jpg',
        imgurl6 : '/img/detail/41/img470.jpg',
        imgurl7 : '/img/detail/41/img471.jpg',
        imgurl8 : '/img/detail/41/img472.jpg',
        imgurl9 : '/img/detail/41/img473.jpg',
        imgurl10 : '/img/detail/41/img474.jpg',
        imgurl11 : '/img/detail/41/img475.jpg',
        imgurl12 : '/img/detail/41/img476.jpg',
        imgurl13 : '/img/detail/41/img477.jpg',
        imgurl14 : '/img/detail/41/img478.jpg',
        imgurl15 : '/img/detail/41/img479.jpg',
        imgurl16 : '/img/detail/41/img480.jpg',
        imgurl17 : '/img/detail/41/img481.jpg',
        imgurl18 : '/img/detail/41/img482.jpg',
        imgurl19 : '/img/detail/41/img483.jpg',
        imgurl20 : '',
    },
    // 25 
    25 :{
        imgurl0 : '/img/detail/41/img484.jpg',
        imgurl1 : '/img/detail/41/img485.jpg',
        imgurl2 : '/img/detail/41/img486.jpg',
        imgurl3 : '/img/detail/41/img487.jpg',
        imgurl4 : '/img/detail/41/img488.jpg',
        imgurl5 : '/img/detail/41/img489.jpg',
        imgurl6 : '/img/detail/41/img490.jpg',
        imgurl7 : '/img/detail/41/img491.jpg',
        imgurl8 : '/img/detail/41/img492.jpg',
        imgurl9 : '/img/detail/41/img493.jpg',
        imgurl10 : '/img/detail/41/img494.jpg',
        imgurl11 : '/img/detail/41/img495.jpg',
        imgurl12 : '/img/detail/41/img496.jpg',
        imgurl13 : '/img/detail/41/img497.jpg',
        imgurl14 : '/img/detail/41/img498.jpg',
        imgurl15 : '/img/detail/41/img499.jpg',
        imgurl16 : '/img/detail/41/img500.jpg',
        imgurl17 : '/img/detail/41/img501.jpg',
        imgurl18 : '/img/detail/41/img502.jpg',
        imgurl19 : '/img/detail/41/img503.jpg',
        imgurl20 : '/img/detail/41/img504.jpg',
    },
    // 26
    26 :{
        imgurl0 : '/img/detail/41/img505.jpg',
        imgurl1 : '/img/detail/41/img506.jpg',
        imgurl2 : '/img/detail/41/img507.jpg',
        imgurl3 : '/img/detail/41/img508.jpg',
        imgurl4 : '/img/detail/41/img509.jpg',
        imgurl5 : '/img/detail/41/img510.jpg',
        imgurl6 : '/img/detail/41/img511.jpg',
        imgurl7 : '/img/detail/41/img512.jpg',
        imgurl8 : '/img/detail/41/img513.jpg',
        imgurl9 : '/img/detail/41/img514.jpg',
        imgurl10 : '/img/detail/41/img515.jpg',
        imgurl11 : '/img/detail/41/img516.jpg',
        imgurl12 : '/img/detail/41/img517.jpg',
        imgurl13 : '/img/detail/41/img518.jpg',
        imgurl14 : '/img/detail/41/img519.jpg',
        imgurl15 : '/img/detail/41/img520.jpg',
        imgurl16 : '/img/detail/41/img521.jpg',
        imgurl17 : '/img/detail/41/img522.jpg',
        imgurl18 : '/img/detail/41/img523.jpg',
        imgurl19 : '/img/detail/41/img524.jpg',
        imgurl20 : '/img/detail/41/img525.jpg',
    },
    // 27
    27 :{
        imgurl0 : '/img/detail/41/img526.jpg',
        imgurl1 : '/img/detail/41/img527.jpg',
        imgurl2 : '/img/detail/41/img528.jpg',
        imgurl3 : '/img/detail/41/img529.jpg',
        imgurl4 : '/img/detail/41/img530.jpg',
        imgurl5 : '/img/detail/41/img531.jpg',
        imgurl6 : '/img/detail/41/img532.jpg',
        imgurl7 : '/img/detail/41/img533.jpg',
        imgurl8 : '/img/detail/41/img534.jpg',
        imgurl9 : '/img/detail/41/img535.jpg',
        imgurl10 : '/img/detail/41/img536.jpg',
        imgurl11 : '/img/detail/41/img537.jpg',
        imgurl12 : '/img/detail/41/img538.jpg',
        imgurl13 : '/img/detail/41/img539.jpg',
        imgurl14 : '/img/detail/41/img540.jpg',
        imgurl15 : '/img/detail/41/img541.jpg',
        imgurl16 : '/img/detail/41/img542.jpg',
        imgurl17 : '/img/detail/41/img543.jpg',
        imgurl18 : '/img/detail/41/img544.jpg',
        imgurl19 : '/img/detail/41/img545.jpg',
        imgurl20 : '/img/detail/41/img546.jpg',
    },
    // 28
    28 :{
        imgurl0 : '/img/detail/41/img547.jpg',
        imgurl1 : '/img/detail/41/img548.jpg',
        imgurl2 : '/img/detail/41/img549.jpg',
        imgurl3 : '/img/detail/41/img550.jpg',
        imgurl4 : '/img/detail/41/img551.jpg',
        imgurl5 : '/img/detail/41/img552.jpg',
        imgurl6 : '/img/detail/41/img553.jpg',
        imgurl7 : '/img/detail/41/img554.jpg',
        imgurl8 : '/img/detail/41/img555.jpg',
        imgurl9 : '/img/detail/41/img556.jpg',
        imgurl10 : '/img/detail/41/img557.jpg',
        imgurl11 : '/img/detail/41/img558.jpg',
        imgurl12 : '/img/detail/41/img559.jpg',
        imgurl13 : '/img/detail/41/img569.jpg',
        imgurl14 : '/img/detail/41/img561.jpg',
        imgurl15 : '/img/detail/41/img562.jpg',
        imgurl16 : '/img/detail/41/img563.jpg',
        imgurl17 : '/img/detail/41/img564.jpg',
        imgurl18 : '/img/detail/41/img565.jpg',
        imgurl19 : '/img/detail/41/img566.jpg',
        imgurl20 : '',
    },
    // 29
    29 :{
        imgurl0 : '/img/detail/41/img567.jpg',
        imgurl1 : '/img/detail/41/img568.jpg',
        imgurl2 : '/img/detail/41/img569.jpg',
        imgurl3 : '/img/detail/41/img570.jpg',
        imgurl4 : '/img/detail/41/img571.jpg',
        imgurl5 : '/img/detail/41/img572.jpg',
        imgurl6 : '/img/detail/41/img573.jpg',
        imgurl7 : '/img/detail/41/img574.jpg',
        imgurl8 : '/img/detail/41/img575.jpg',
        imgurl9 : '/img/detail/41/img576.jpg',
        imgurl10 : '/img/detail/41/img577.jpg',
        imgurl11 : '/img/detail/41/img578.jpg',
        imgurl12 : '/img/detail/41/img579.jpg',
        imgurl13 : '/img/detail/41/img580.jpg',
        imgurl14 : '/img/detail/41/img581.jpg',
        imgurl15 : '/img/detail/41/img582.jpg',
        imgurl16 : '/img/detail/41/img583.jpg',
        imgurl17 : '/img/detail/41/img584.jpg',
        imgurl18 : '/img/detail/41/img585.jpg',
        imgurl19 : '',
        imgurl20 : 'g',
    },
    // 30
    30 :{
        imgurl0 : '/img/detail/41/img586.jpg',
        imgurl1 : '/img/detail/41/img587.jpg',
        imgurl2 : '/img/detail/41/img588.jpg',
        imgurl3 : '/img/detail/41/img589.jpg',
        imgurl4 : '/img/detail/41/img590.jpg',
        imgurl5 : '/img/detail/41/img591.jpg',
        imgurl6 : '/img/detail/41/img592.jpg',
        imgurl7 : '/img/detail/41/img593.jpg',
        imgurl8 : '/img/detail/41/img594.jpg',
        imgurl9 : '/img/detail/41/img595.jpg',
        imgurl10 : '/img/detail/41/img596.jpg',
        imgurl11 : '/img/detail/41/img597.jpg',
        imgurl12 : '/img/detail/41/img598.jpg',
        imgurl13 : '/img/detail/41/img599.jpg',
        imgurl14 : '/img/detail/41/img600.jpg',
        imgurl15 : '/img/detail/41/img601.jpg',
        imgurl16 : '/img/detail/41/img602.jpg',
        imgurl17 : '/img/detail/41/img603.jpg',
        imgurl18 : '/img/detail/41/img604.jpg',
        imgurl19 : '',
        imgurl20 : '',
    },
    // 31
    31 :{
        imgurl0 : '/img/detail/41/img605.jpg',
        imgurl1 : '/img/detail/41/img606.jpg',
        imgurl2 : '/img/detail/41/img607.jpg',
        imgurl3 : '/img/detail/41/img608.jpg',
        imgurl4 : '/img/detail/41/img609.jpg',
        imgurl5 : '/img/detail/41/img610.jpg',
        imgurl6 : '/img/detail/41/img611.jpg',
        imgurl7 : '/img/detail/41/img612.jpg',
        imgurl8 : '/img/detail/41/img613.jpg',
        imgurl9 : '/img/detail/41/img614.jpg',
        imgurl10 : '/img/detail/41/img615.jpg',
        imgurl11 : '/img/detail/41/img616.jpg',
        imgurl12 : '/img/detail/41/img617.jpg',
        imgurl13 : '/img/detail/41/img618.jpg',
        imgurl14 : '/img/detail/41/img619.jpg',
        imgurl15 : '/img/detail/41/img620.jpg',
        imgurl16 : '/img/detail/41/img621.jpg',
        imgurl17 : '/img/detail/41/img622.jpg',
        imgurl18 : '/img/detail/41/img623.jpg',
        imgurl19 : '',
        imgurl20 : '',
    },
    // 32
    32 :{
        imgurl0 : '/img/detail/41/img645.jpg',
        imgurl1 : '/img/detail/41/img646.jpg',
        imgurl2 : '/img/detail/41/img647.jpg',
        imgurl3 : '/img/detail/41/img648.jpg',
        imgurl4 : '/img/detail/41/img649.jpg',
        imgurl5 : '/img/detail/41/img650.jpg',
        imgurl6 : '/img/detail/41/img651.jpg',
        imgurl7 : '/img/detail/41/img652.jpg',
        imgurl8 : '/img/detail/41/img653.jpg',
        imgurl9 : '/img/detail/41/img654.jpg',
        imgurl10 : '/img/detail/41/img655.jpg',
        imgurl11 : '/img/detail/41/img656.jpg',
        imgurl12 : '/img/detail/41/img657.jpg',
        imgurl13 : '/img/detail/41/img658.jpg',
        imgurl14 : '/img/detail/41/img659.jpg',
        imgurl15 : '/img/detail/41/img660.jpg',
        imgurl16 : '/img/detail/41/img661.jpg',
        imgurl17 : '/img/detail/41/img662.jpg',
        imgurl18 : '/img/detail/41/img663.jpg',
        imgurl19 : '/img/detail/41/img664.jpg',
        imgurl20 : '/img/detail/41/img665.jpg',
    },
    // 33
    33 :{
        imgurl0 : '/img/detail/41/img666.jpg',
        imgurl1 : '/img/detail/41/img667.jpg',
        imgurl2 : '/img/detail/41/img668.jpg',
        imgurl3 : '/img/detail/41/img669.jpg',
        imgurl4 : '/img/detail/41/img670.jpg',
        imgurl5 : '/img/detail/41/img671.jpg',
        imgurl6 : '/img/detail/41/img672.jpg',
        imgurl7 : '/img/detail/41/img673.jpg',
        imgurl8 : '/img/detail/41/img674.jpg',
        imgurl9 : '/img/detail/41/img675.jpg',
        imgurl10 : '/img/detail/41/img676.jpg',
        imgurl11 : '/img/detail/41/img677.jpg',
        imgurl12 : '',
        imgurl13 : '',
        imgurl14 : '',
        imgurl15 : '',
        imgurl16 : '',
        imgurl17 : '',
        imgurl18 : '',
        imgurl19 : '',
        imgurl20 : '',
    },
    // 34
    34 :{
        imgurl0 : '/img/detail/41/img678.jpg',
        imgurl1 : '/img/detail/41/img679.jpg',
        imgurl2 : '/img/detail/41/img680.jpg',
        imgurl3 : '/img/detail/41/img681.jpg',
        imgurl4 : '/img/detail/41/img682.jpg',
        imgurl5 : '/img/detail/41/img683.jpg',
        imgurl6 : '/img/detail/41/img684.jpg',
        imgurl7 : '/img/detail/41/img685.jpg',
        imgurl8 : '/img/detail/41/img686.jpg',
        imgurl9 : '/img/detail/41/img687.jpg',
        imgurl10 : '/img/detail/41/img688.jpg',
        imgurl11 : '/img/detail/41/img689.jpg',
        imgurl12 : '/img/detail/41/img690.jpg',
        imgurl13 : '/img/detail/41/img691.jpg',
        imgurl14 : '/img/detail/41/img692.jpg',
        imgurl15 : '/img/detail/41/img693.jpg',
        imgurl16 : '/img/detail/41/img694.jpg',
        imgurl17 : '/img/detail/41/img695.jpg',
        imgurl18 : '/img/detail/41/img696.jpg',
        imgurl19 : '/img/detail/41/img697.jpg',
        imgurl20 : '',
    },
    // 35
    35 :{
        imgurl0 : '/img/detail/41/img698.jpg',
        imgurl1 : '/img/detail/41/img699.jpg',
        imgurl2 : '/img/detail/41/img700.jpg',
        imgurl3 : '/img/detail/41/img701.jpg',
        imgurl4 : '/img/detail/41/img702.jpg',
        imgurl5 : '/img/detail/41/img703.jpg',
        imgurl6 : '/img/detail/41/img704.jpg',
        imgurl7 : '/img/detail/41/img705.jpg',
        imgurl8 : '/img/detail/41/img706.jpg',
        imgurl9 : '/img/detail/41/img707.jpg',
        imgurl10 : '/img/detail/41/img708.jpg',
        imgurl11 : '/img/detail/41/img709.jpg',
        imgurl12 : '/img/detail/41/img710.jpg',
        imgurl13 : '/img/detail/41/img711.jpg',
        imgurl14 : '/img/detail/41/img712.jpg',
        imgurl15 : '/img/detail/41/img713.jpg',
        imgurl16 : '/img/detail/41/img714.jpg',
        imgurl17 : '/img/detail/41/img715.jpg',
        imgurl18 : '/img/detail/41/img716.jpg',
        imgurl19 : '/img/detail/41/img717.jpg',
        imgurl20 : '/img/detail/41/img718.jpg',
    },
    // 36
    36 :{
        imgurl0 : '/img/detail/41/img719.jpg',
        imgurl1 : '/img/detail/41/img720.jpg',
        imgurl2 : '/img/detail/41/img721.jpg',
        imgurl3 : '/img/detail/41/img722.jpg',
        imgurl4 : '/img/detail/41/img723.jpg',
        imgurl5 : '/img/detail/41/img724.jpg',
        imgurl6 : '/img/detail/41/img725.jpg',
        imgurl7 : '/img/detail/41/img726.jpg',
        imgurl8 : '/img/detail/41/img727.jpg',
        imgurl9 : '/img/detail/41/img728.jpg',
        imgurl10 : '/img/detail/41/img729.jpg',
        imgurl11 : '/img/detail/41/img730.jpg',
        imgurl12 : '/img/detail/41/img731.jpg',
        imgurl13 : '/img/detail/41/img732.jpg',
        imgurl14 : '/img/detail/41/img733.jpg',
        imgurl15 : '/img/detail/41/img734.jpg',
        imgurl16 : '/img/detail/41/img735.jpg',
        imgurl17 : '/img/detail/41/img736.jpg',
        imgurl18 : '/img/detail/41/img737.jpg',
        imgurl19 : '/img/detail/41/img738.jpg',
        imgurl20 : '/img/detail/41/img739.jpg',
    },
    // 37
    37 :{
        imgurl0 : '/img/detail/41/img749.jpg',
        imgurl1 : '/img/detail/41/img741.jpg',
        imgurl2 : '/img/detail/41/img742.jpg',
        imgurl3 : '/img/detail/41/img743.jpg',
        imgurl4 : '/img/detail/41/img744.jpg',
        imgurl5 : '/img/detail/41/img745.jpg',
        imgurl6 : '/img/detail/41/img746.jpg',
        imgurl7 : '/img/detail/41/img747.jpg',
        imgurl8 : '/img/detail/41/img748.jpg',
        imgurl9 : '/img/detail/41/img749.jpg',
        imgurl10 : '/img/detail/41/img750.jpg',
        imgurl11 : '/img/detail/41/img751.jpg',
        imgurl12 : '/img/detail/41/img752.jpg',
        imgurl13 : '/img/detail/41/img753.jpg',
        imgurl14 : '/img/detail/41/img754.jpg',
        imgurl15 : '/img/detail/41/img755.jpg',
        imgurl16 : '/img/detail/41/img756.jpg',
        imgurl17 : '/img/detail/41/img757.jpg',
        imgurl18 : '/img/detail/41/img758.jpg',
        imgurl19 : '/img/detail/41/img759.jpg',
        imgurl20 : '',
    },
    // 38
    38 :{
        imgurl0 : '/img/detail/41/img760.jpg',
        imgurl1 : '/img/detail/41/img761.jpg',
        imgurl2 : '/img/detail/41/img762.jpg',
        imgurl3 : '/img/detail/41/img763.jpg',
        imgurl4 : '/img/detail/41/img764.jpg',
        imgurl5 : '/img/detail/41/img765.jpg',
        imgurl6 : '/img/detail/41/img766.jpg',
        imgurl7 : '/img/detail/41/img767.jpg',
        imgurl8 : '/img/detail/41/img768.jpg',
        imgurl9 : '/img/detail/41/img769.jpg',
        imgurl10 : '/img/detail/41/img770.jpg',
        imgurl11 : '/img/detail/41/img771.jpg',
        imgurl12 : '/img/detail/41/img772.jpg',
        imgurl13 : '/img/detail/41/img773.jpg',
        imgurl14 : '/img/detail/41/img774.jpg',
        imgurl15 : '/img/detail/41/img775.jpg',
        imgurl16 : '/img/detail/41/img776.jpg',
        imgurl17 : '/img/detail/41/img777.jpg',
        imgurl18 : '/img/detail/41/img778.jpg',
        imgurl19 : '/img/detail/41/img779.jpg',
        imgurl20 : '/img/detail/41/img780.jpg',
    },
    // 39
    39 :{
        imgurl0 : '/img/detail/41/img780.jpg',
        imgurl1 : '/img/detail/41/img781.jpg',
        imgurl2 : '/img/detail/41/img782.jpg',
        imgurl3 : '/img/detail/41/img783.jpg',
        imgurl4 : '/img/detail/41/img784.jpg',
        imgurl5 : '/img/detail/41/img785.jpg',
        imgurl6 : '/img/detail/41/img786.jpg',
        imgurl7 : '/img/detail/41/img787.jpg',
        imgurl8 : '/img/detail/41/img788.jpg',
        imgurl9 : '/img/detail/41/img789.jpg',
        imgurl10 : '/img/detail/41/img790.jpg',
        imgurl11 : '/img/detail/41/img791.jpg',
        imgurl12 : '/img/detail/41/img792.jpg',
        imgurl13 : '/img/detail/41/img793.jpg',
        imgurl14 : '/img/detail/41/img794.jpg',
        imgurl15 : '/img/detail/41/img795.jpg',
        imgurl16 : '/img/detail/41/img796.jpg',
        imgurl17 : '/img/detail/41/img797.jpg',
        imgurl18 : '/img/detail/41/img798.jpg',
        imgurl19 : '/img/detail/41/img799.jpg',
        imgurl20 : '/img/detail/41/img800.jpg',
    },
    // 40
    40 :{
        imgurl0 : '/img/detail/41/img801.jpg',
        imgurl1 : '/img/detail/41/img802.jpg',
        imgurl2 : '/img/detail/41/img803.jpg',
        imgurl3 : '/img/detail/41/img804.jpg',
        imgurl4 : '/img/detail/41/img805.jpg',
        imgurl5 : '/img/detail/41/img806.jpg',
        imgurl6 : '/img/detail/41/img807.jpg',
        imgurl7 : '/img/detail/41/img808.jpg',
        imgurl8 : '/img/detail/41/img809.jpg',
        imgurl9 : '/img/detail/41/img810.jpg',
        imgurl10 : '/img/detail/41/img811.jpg',
        imgurl11 : '/img/detail/41/img812.jpg',
        imgurl12 : '/img/detail/41/img813.jpg',
        imgurl13 : '/img/detail/41/img814.jpg',
        imgurl14 : '/img/detail/41/img815.jpg',
        imgurl15 : '/img/detail/41/img816.jpg',
        imgurl16 : '/img/detail/41/img817.jpg',
        imgurl17 : '/img/detail/41/img818.jpg',
        imgurl18 : '/img/detail/41/img819.jpg',
        imgurl19 : '/img/detail/41/img820.jpg',
        imgurl20 : '/img/detail/41/img821.jpg',
    },
    // 41
    41 :{
        imgurl0 : '/img/detail/41/img822.jpg',
        imgurl1 : '/img/detail/41/img823.jpg',
        imgurl2 : '/img/detail/41/img824.jpg',
        imgurl3 : '/img/detail/41/img825.jpg',
        imgurl4 : '/img/detail/41/img826.jpg',
        imgurl5 : '/img/detail/41/img827.jpg',
        imgurl6 : '/img/detail/41/img828.jpg',
        imgurl7 : '/img/detail/41/img829.jpg',
        imgurl8 : '/img/detail/41/img830.jpg',
        imgurl9 : '/img/detail/41/img831.jpg',
        imgurl10 : '/img/detail/41/img832.jpg',
        imgurl11 : '/img/detail/41/img833.jpg',
        imgurl12 : '',
        imgurl13 : '',
        imgurl14 : '',
        imgurl15 : '',
        imgurl16 : '',
        imgurl17 : '',
        imgurl18 : '',
        imgurl19 : '',
        imgurl20 : '',
    },

}

export default img_data;